//autism
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'

function Cancer(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-04-cancer-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Cancer"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Cancer refers to any one of a large number of
                                    diseases characterized by the development of
                                    abnormal cells that divide uncontrollably and
                                    have the ability to infiltrate and destroy normal
                                    body tissue. Cancer often has the ability to
                                    spread throughout your body.
                                </p>
                                <p>
                                    <b>Cancer</b> is a group of <a href='https://en.wikipedia.org/wiki/Disease' className='links'>diseases</a> involving <a className='links' href='https://en.wikipedia.org/wiki/Cell_growth#Disorders'>abnormal cell growth</a> with the potential to <a href='https://en.wikipedia.org/wiki/Invasion_(cancer)' className='links'>invade</a> or <a href='https://en.wikipedia.org/wiki/Metastasis' className='links'>spread</a>  to other parts of the body
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Cancer/1.png")} alt="cancer" />
                                    </div>
                                </div>



                                <p><b>Symptoms</b></p>
                                <p>Unexplained loss of weight or <a href='https://www.medicinenet.com/loss_of_appetite/symptoms.htm' className='links'>loss of appetite</a>, </p>
                                <p>
                                    A new type of pain in the bones or other parts of the body that may
                                    be steadily worsening, or come and go, but is unlike previous pains
                                    one has had before
                                </p>
                                <p>Persistent <a href='https://www.medicinenet.com/fatigue_and_tiredness/symptoms.htm' className='links'>fatigue</a>, <a href='https://www.medicinenet.com/nausea_and_vomiting/article.htm' className='links'>nausea</a>, or <a className='links' href='https://www.medicinenet.com/nausea_and_vomiting/article.htm'>vomiting</a>,</p>
                                <p>
                                    Unexplained low-grade <a href='https://www.medicinenet.com/aches_pain_fever/article.htm' className='links'>fevers</a> may be either persistent or come and
                                    go,{" "}
                                </p>
                                <p>Recurring infections which will not clear with usual treatment,</p>
                                <p>Change in bowel or bladder habits</p>
                                <p>A <a href='https://www.medicinenet.com/sore_throat_pharyngitis/article.htm' className='links'>sore throat</a> that does not heal</p>
                                <p>
                                    Unusual bleeding or discharge (for example, <a href='https://www.medicinenet.com/breast_anatomy/article.htm' className='links'>nipple</a> secretions or a
                                    "sore" that will not heal that oozes material)
                                </p>
                                <p>Thickening or lump in the breast, testicles, or elsewhere</p>
                                <p><a href='https://www.medicinenet.com/dyspepsia/article.htm' className='links'>Indigestion</a> (usually chronic) or <a className='links' href='https://www.medicinenet.com/swallowing/article.htm'>difficulty swallowing</a></p>
                                <p>
                                    Obvious change in the size, color, shape, or thickness of a wart or
                                    mole
                                </p>
                                <p>Nagging <a href='https://www.medicinenet.com/cough/symptoms.htm' className='links'>cough</a> or <a className='links' href='https://www.medicinenet.com/hoarseness/article.htm'>hoarseness</a></p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Cancer">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Cancer;